export default "__VITE_ASSET__CUWqL529__";